import { render, staticRenderFns } from "./RisingStarProgressBar.vue?vue&type=template&id=0cb0ca76&scoped=true"
import script from "./RisingStarProgressBar.vue?vue&type=script&lang=js"
export * from "./RisingStarProgressBar.vue?vue&type=script&lang=js"
import style0 from "./RisingStarProgressBar.vue?vue&type=style&index=0&id=0cb0ca76&prod&scoped=true&lang=css"
import style1 from "./RisingStarProgressBar.vue?vue&type=style&index=1&id=0cb0ca76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0ca76",
  null
  
)

export default component.exports